import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import CloseIcon from "./CloseIcon";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const navigate = useNavigate()
  const navigateHome = () => {
    // Optionally navigate to '/' when Home is clicked
    navigate('/');
  };
  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">

        <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} 
        className="animate pointer">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="home"
            spy={true}
            smooth={true}
            offset={-60}

          >
            Home
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="about"
            spy={true}
            smooth={true}
            offset={-60}

          >
            About
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="services"
            spy={true}
            smooth={true}
            offset={-60}

          >
            Services
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="contact"
            spy={true}
            smooth={true}
            offset={-60}

          >
            Contact
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link activeClass="active" style={{ padding: "10px 15px" }} to="yojna" spy={true} smooth={true} offset={-160} onClick={() => toggleSidebar(!sidebarOpen)}>
            <Button style={{ color: 'gold', backgroundColor: "#1B4F72", borderRadius: "20px" }}> योजनाएं</Button>
          </Link>
        </li>
      </UlStyle>

    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  backgroundcolor:#1B4F72;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
